
    import "src/shared/columns/Inventory/index.module.scss?farm_css_modules";
    
    export default {"hamburgForNavbar": `hamburgForNavbar-2fde480d`,"oderId": `oderId-2fde480d`,"skuText": `skuText-2fde480d`,"toMakeResponsiveSidebar": `toMakeResponsiveSidebar-2fde480d`}
    